import { render, staticRenderFns } from "./mian15.vue?vue&type=template&id=f0373eca&scoped=true"
import script from "./mian15.vue?vue&type=script&lang=ts"
export * from "./mian15.vue?vue&type=script&lang=ts"
import style0 from "./mian15.vue?vue&type=style&index=0&id=f0373eca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0373eca",
  null
  
)

export default component.exports